export const WEBHOOK_URL = process.env.VUE_APP_API_URL;

export const ENDPOINT = {
  USERS: '/users',
  GET_BOOK: '/get-book'
};

export const PER_PAGE_10 = 10;
export const PER_PAGE_100 = 100;
